import Section from './Section'

const Table = (props) => (
	<div className='row'>
		<div className='col-12'>
			<div className='col-12'>
				{props.checklist.sections.map((item, index) => (
					<Section
						key={item.id}
						index={index}
						{...item}
						sectionId={item.id}
						onChangeItem={props.onChangeItem}
						onChangeSection={props.onChangeSection}
						onChangeComment={props.onChangeComment}
						status={props.checklist.status}
						language={props.language}
						dispatch={props.dispatch}
					/>
				))}
			</div>
		</div>
	</div>
)

export default Table
